(function () {
  if (theme?.settings?.cartType === 'page') return;

  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { open: true }
    }));
  }

  // The submit interception below stops the theme's own product-form handler,
  // which is what normally publishes cartUpdate. Without it the header/mobile
  // dock <cart-count> keeps its old value (the drawer is fine, it re-renders
  // server-side through cart:refresh), so publish it here as well.
  async function publishCartUpdate(productVariantId) {
    if (!window.theme?.pubsub) return;

    try {
      const cart = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();

      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: 'wishlist-king',
        productVariantId,
        cart
      });
    } catch (error) {
      console.log(error);
    }
  }

  // Intercept wk:add_to_cart (works if WK event is cancelable)
  document.addEventListener('wk:add_to_cart', async (event) => {
    event.preventDefault();

    const variantId = event.detail?.variant_id || event.detail?.variantId;
    const quantity = event.detail?.quantity || 1;
    if (!variantId) return;

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });

    if (response.ok) {
      await publishCartUpdate(variantId);
      openCartDrawer();
    }
  });

  // Intercept form submits to /cart/add in capture phase (before WK's listener)
  // so WK never gets to do its own submit + redirect
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;
    if (!document.querySelector('cart-drawer')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const formData = new FormData(form);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (response.ok) {
      await publishCartUpdate(formData.get('id'));
      openCartDrawer();
    }
  }, true);

  // Intercept explicit location.assign('/cart') calls from WK
  const _assign = window.location.assign.bind(window.location);
  window.location.assign = function (url) {
    if (document.querySelector('cart-drawer') && (url === '/cart' || url.endsWith('/cart'))) {
      openCartDrawer();
      return;
    }
    _assign(url);
  };
})();
